/**
 * `campaign-studio` namespace catalog (ADR 0310 Phase C) — the campaign canvas type's vocabulary under the canvas framework's fixed type-key contract; chassis strings live in the `canvas` namespace. Distinct from the Marketing `campaigns` console.
 */
export const messages = {
  editorHeading: 'Campaign editor',
  docName: 'Campaign name',
  deleteDoc: 'Delete campaign',
  deleteDocTitle: 'Delete "{{name}}"?',
  deleteDocBody: 'The campaign working copy and its version history are permanently removed. The chat artifact it was opened from is not affected. This cannot be undone.',
  deleteDocDone: 'Campaign deleted.',
  deleteDocFailed: 'Could not delete this campaign.',
  col_channels: 'Channels',
  col_funnel: 'Funnel',
  col_assets: 'Assets',
  add_channel: 'Channel',
  add_stage: 'Funnel stage',
  add_asset: 'Asset',
  graphEmpty: "No funnel stages yet \u2014 add one to map the journey.",
  graphSurface: 'Funnel board',
  boardKpiCount_one: "{{count}} KPI",
  boardKpiCount_other: "{{count}} KPIs",
  stage_awareness: 'Awareness',
  stage_consideration: 'Consideration',
  stage_conversion: 'Conversion',
  stage_retention: 'Retention',
  stage_advocacy: 'Advocacy',
  // ADR 0340 — catalog prop/option labels (the chassis PropertyField
  // resolves prop_<name> / opt_<name>_<value> with the code label as fallback).
  opt_stage_advocacy: "Advocacy",
  opt_stage_awareness: "Awareness",
  opt_stage_consideration: "Consideration",
  opt_stage_conversion: "Conversion",
  opt_stage_retention: "Retention",
  opt_type_content: "Content",
  opt_type_display: "Display",
  opt_type_email: "Email",
  opt_type_events: "Events",
  opt_type_pr: "PR",
  opt_type_search: "Search",
  opt_type_sms: "SMS",
  opt_type_social: "Social",
  prop_audience: "Audience",
  prop_body: "Body",
  prop_channel: "Channel",
  prop_cta: "Call to action",
  prop_description: "Description",
  prop_format: "Format",
  prop_headline: "Headline",
  prop_name: "Channel name",
  prop_objective: "Objective",
  prop_tactic: "Tactic",
  prop_budget: "Budget",
  prop_kpis: "KPIs (one per line)",
  prop_stage: "Stage",
  prop_type: "Type",
};
